import { render } from "./PlantAlarmSystem.vue?vue&type=template&id=9390b314&ts=true"
import script from "./PlantAlarmSystem.ts?vue&type=script&lang=ts"
export * from "./PlantAlarmSystem.ts?vue&type=script&lang=ts"

import "./PlantAlarmSystem.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__